module.exports = __webpack_public_path__ + "fonts/Rubik-Italic.25387d7b.ttf";